import React from 'react'

function ConnectSvg() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="44" viewBox="0 0 60 44" fill="none">
      <path
        d="M4.66755 23.8542C3.65463 22.8412 2.01234 22.8412 0.99943 23.8542C-0.0134817 24.8671 -0.0134817 26.5092 0.99943 27.5221L16.5619 43.0846C17.5748 44.0975 19.2171 44.0975 20.23 43.0846L58.2716 5.04304C59.2846 4.03012 59.2846 2.38783 58.2716 1.37492C57.2587 0.362007 55.6166 0.362007 54.6037 1.37492L18.396 37.5824L4.66755 23.8542Z"
        fill="white"
      />
    </svg>
  )
}

export default ConnectSvg
